import ContentLoader from 'react-content-loader'
import { COLORS } from 'assets/styles/colors'

const NavHeaderSkeleton = () => {
  const borderRadius = 5
  const height = 32
  const width = 440

  return (
    <ContentLoader
      backgroundColor={COLORS.NEUTRAL_200}
      foregroundColor={COLORS.WHITE}
      style={{ height, width }}
    >
      <rect
        height={height}
        rx={borderRadius}
        ry={borderRadius}
        width={width}
        x={0}
        y={0}
      />
    </ContentLoader>
  )
}

export default NavHeaderSkeleton
